"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Printer from foundation/Printer
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Printer = createSVGIcon(
  <path
    d="M2.66 4.345v3.793H.817c-.446 0-.818.313-.818.69v5.862c0 .376.372.69.818.69H2.66v3.103c0 .18.195.345.41.345h11.863c.214 0 .409-.165.409-.345v-3.104h1.84c.447 0 .819-.313.819-.69V8.829c0-.377-.372-.69-.818-.69H15.34V4.345c0-.18-.195-.345-.41-.345H3.069c-.221.003-.404.19-.409.345m.817.345h11.046v3.448H3.477zM.818 8.828h16.364v5.862H15.34v-1.724c0-.181-.195-.345-.41-.345H3.069c-.214 0-.409.164-.409.345v1.724H.82zm12.068.69c-.339 0-.613.23-.613.516s.274.518.613.518c.34 0 .614-.232.614-.518 0-.285-.275-.517-.614-.517m2.046 0c-.34 0-.614.23-.614.516s.275.518.614.518.613-.232.613-.518c0-.285-.274-.517-.613-.517M3.477 13.31h11.046v4.828H3.477z"
    transform="translate(-560 -290) translate(470 50) translate(90 187) translate(0 49)"
    fill="currentColor"
    fillRule="nonzero"
  />,
  "Printer",
  { viewBox: "0 0 18 15", titleAccess: "Printer", className: legacyIconCls() }
);
